var map = {
	"./IMG_0633.mp4": 781,
	"./IMG_0636.mp4": 44,
	"./IMG_0637.mp4": 801,
	"./VID-20230703-WA0000(1).mp4": 93,
	"./VID-20230703-WA0001(1).mp4": 922,
	"./VID-20230703-WA0003.mp4": 912,
	"./VID_20220805_175735.mp4": 403,
	"./VID_20221018_162432.mp4": 852,
	"./VID_20230121_170912.mp4": 545,
	"./VID_20230423_183427.mp4": 795,
	"./cool_surfing_video.mp4": 95,
	"./rainbow.mp4": 427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;